import { render, staticRenderFns } from "./StreamingStatusLabel.vue?vue&type=template&id=2a53aecc"
import script from "./StreamingStatusLabel.vue?vue&type=script&lang=js"
export * from "./StreamingStatusLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports